import graphql from 'babel-plugin-relay/macro'
import Page from 'components/Page'
import QueryRender from 'components/QueryRender'
import React from 'react'
import EquipmentTable from '../components/EquipmentTable'

const query = graphql`
  query EquipmentIndexQuery {
    viewer {
      ...EquipmentTable_viewer
    }
  }
`

export default function EquipmentIndex() {
  return (
    <Page
      title='Equipos'
    >
      <QueryRender
        query={query}
        render={({ props }) => <EquipmentTable viewer={props.viewer} />}
      />
    </Page>
  )
}